module.exports = __webpack_public_path__ + "img/switzerland-endocrine-nutritional-metabolic-diseases-female.4825f829.png";